<template>
  <base-radio-group :options="options" v-model="localValue" :state="state" :errorMsg="errorMsg"></base-radio-group>
</template>

<script>

export default {
  components: {
    'base-radio-group': () => import('@/components/base/forms/BaseRadioGroup')
  },
  props: {
    value: [String, Object, Boolean],
    options: {
      type: Array,
      required: false,
      default () {
        return [
          { value: 'NIF', text: 'NIF' },
          { value: 'NIE', text: 'NIE' }
        ]
      }
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      localValue: null
    }
  },
  created () {
    this.localValue = this.value
    this.$watch('localValue', value => {
      this.$emit('input', value)
    })
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/forms/RadioButtonNieNif.vue